export default "__VITE_ASSET__BIjIuw2W__"